import { gps } from './gps'

const inside = require('point-in-polygon')

export const polygon = {
  async verifyCoords (polygon) {
    try {
      const { latitude, longitude } = await gps.getCoords()
      console.log('coords', latitude, longitude)
      return inside([latitude, longitude], polygon)
    } catch (err) {
      console.log(err)
      throw Error('Error al momento de verificar la ubicación de su teléfono')
    }
  }
}

gps.getCoords()
